import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useParams, useRouteMatch, Switch, Route } from 'react-router-dom';

import { getConversation } from '@mssgme/store';
import { useActions, useBooleanHandler, useFetching } from '@mssgme/hooks';
import { useBreakpoints } from '@mssgme/ui';

import {
    MessageList,
    MessagesHeader,
    MessagesFooter,
    ClientCard,
    QuickReplyEdit,
    QuickReplyList,
    QuickRepliesMatch,
} from '../UI';

import styles from './MessagesPage.scss';

export default function MessagesPage() {
    const { path } = useRouteMatch();
    const { contactId } = useParams();
    const { api } = useActions();
    const { isBelowDesktop } = useBreakpoints();
    const [isClientCardOpen, openCard, closeCard] = useBooleanHandler();
    const conversation = useSelector((state) => getConversation(state, contactId));
    const readConversation = useFetching(api.conversations.read);

    useEffect(() => {
        if (!conversation) {
            void api.conversations.retrieve({ contactId });
        }
    }, [conversation]);

    if (!conversation) return null;

    function onRead() {
        if (!conversation.read) {
            void readConversation.run({ contactId });
        }
    }

    return (
        <div
            className={styles.root}
            key={`contact-${contactId}`}
            onMouseMove={onRead}
            onClick={onRead}
            onKeyPress={onRead}
        >
            <Switch>
                <Route path={path}>
                    <div className={styles.main} hidden={isClientCardOpen}>
                        <Switch>
                            <Route path={`${path}/replies/new`} exact>
                                <QuickReplyEdit />
                            </Route>
                            <Route path={`${path}/replies/:replyId`} exact>
                                <QuickReplyEdit />
                            </Route>
                            <Route path={`${path}/replies`} exact>
                                <QuickReplyList />
                            </Route>
                        </Switch>
                        <QuickRepliesMatch />
                        <MessagesHeader openClientCard={openCard} />
                        <MessageList />
                        <MessagesFooter />
                    </div>
                    {(!isBelowDesktop || isClientCardOpen) && <ClientCard onClose={closeCard} />}
                </Route>
            </Switch>
        </div>
    );
}
